import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VapeFreeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vape_free"}/>
}
